import { message } from "antd";
import { CustomerService } from "../services/customers";
import { dataUriToBlob } from "../utils";
import fileServices from "../services/storage/index1";

const namespace = "customers";
const initialState = {
  list: [],
  loading: {
    fetchList: false,
    inviteUser: false,
    editUser: false,
    loadMore: false,
    removeUser: false,
  },
  total: 0,
};

export const fetchList = (params) => ({
  type: `${namespace}/fetchList`,
  payload: params,
});
export const fetchMore = (params) => ({
  type: `${namespace}/fetchMore`,
  payload: params,
});
export const activateUser = (id) => ({
  type: `${namespace}/activateUser`,
  payload: id,
});

export const deactivateUser = (id) => ({
  type: `${namespace}/deactivateUser`,
  payload: id,
});

export const inviteUser = (data) => ({
  type: `${namespace}/inviteUser`,
  payload: data,
});
export const editUser = (id, data) => ({
  type: `${namespace}/editUser`,
  payload: { id, data },
});
export const removeUser = (id) => ({
  type: `${namespace}/removeUser`,
  payload: id,
});

export default {
  namespace,
  state: initialState,
  effects: {
    *removeUser({ payload }, { call, put }) {
      yield put({ type: "startLoading", loadingType: "removeUser" });
      try {
        const response = yield call(CustomerService.removeUser, payload);
        if (response.data) {
          message.success("User removed successfully!");
        }
        return response;
      } catch (error) {
        throw new Error(error);
      } finally {
        yield put({ type: "stopLoading", loadingType: "removeUser" });
      }
    },
    *editUser({ payload }, { call, put }) {
      yield put({ type: "startLoading", loadingType: "editUser" });
      try {
        if (payload.data.photo) {
          const blob = dataUriToBlob(payload.data.photo);
          const photoFile = new File([blob], "item.jpg", {
            type: blob.type,
          });

          const { url } = yield call(fileServices.uploadFile, {
            file: photoFile,
          });
          payload.data.photo = url;
        }

        const response = yield call(
          CustomerService.editUser,
          payload.id,
          payload.data,
        );
        if (response.data) {
          message.success("User updated successfully!");
        }
        return response;
      } catch (error) {
        throw new Error(error);
      } finally {
        yield put({ type: "stopLoading", loadingType: "editUser" });
      }
    },
    *inviteUser({ payload }, { call, put }) {
      yield put({ type: "startLoading", loadingType: "inviteUser" });
      try {
        const response = yield call(CustomerService.inviteUser, payload);
        if (response.data) {
          message.success("User invited successfully!");
        }
        return response;
      } catch (error) {
        throw new Error(error);
      } finally {
        yield put({ type: "stopLoading", loadingType: "inviteUser" });
      }
    },
    *deactivateUser({ payload }, { call, put }) {
      try {
        const response = yield call(CustomerService.deactivateUser, payload);
        yield put({
          type: "updateCustomers",
          payload: response.data,
        });
        message.success("User deactivated successfully");
      } catch (error) {
        console.error("Error deactivating user:", error);
      }
    },
    *activateUser({ payload }, { call, put }) {
      try {
        const response = yield call(CustomerService.activateUser, payload);
        yield put({
          type: "updateCustomers",
          payload: response.data,
        });
        message.success("User activated successfully");
      } catch (error) {
        console.error("Error activating user:", error);
      }
    },
    *fetchList({ payload }, { call, put }) {
      yield put({ type: "startLoading", loadingType: "fetchList" });
      try {
        const response = yield call(CustomerService.fetchList, payload);
        yield put({
          type: "setCustomers",
          payload: { list: response.data.list, total: response.data.total },
        });
      } catch (error) {
        console.error("Error fetching customers:", error);
      } finally {
        yield put({ type: "stopLoading", loadingType: "fetchList" });
      }
    },
    *fetchMore({ payload }, { call, put }) {
      yield put({ type: "startLoading", loadingType: "loadMore" });
      try {
        const response = yield call(CustomerService.fetchList, payload);
        yield put({
          type: "updateList",
          payload: { list: response.data.list, total: response.data.total },
        });
      } catch (error) {
        console.error("Error fetching more customers:", error);
      } finally {
        yield put({ type: "stopLoading", loadingType: "loadMore" });
      }
    },
  },
  reducers: {
    updateCustomers(state, { payload }) {
      const updatedList = state.list.map((customer) =>
        customer.id === payload.id ? payload : customer,
      );
      return { ...state, list: updatedList };
    },
    updateList(state, { payload }) {
      return {
        ...state,
        list: [...state.list, ...payload.list],
        total: payload.total,
      };
    },

    setCustomers(state, { payload }) {
      return { ...state, list: payload.list, total: payload.total };
    },
    startLoading(state, { loadingType }) {
      return { ...state, loading: { ...state.loading, [loadingType]: true } };
    },
    stopLoading(state, { loadingType }) {
      return { ...state, loading: { ...state.loading, [loadingType]: false } };
    },
  },
};
